/**
 * Takes in an array of FHIR Encounter objects and returns an array of encounter objects.
 * @param {Array<EncounterData>} data - the array of encounter data to convert into encounter objects.
 * @returns {Array<Encounter>} - an array of encounter objects.
 */
export function fEncounters(data) {
  const encounterArray = [];
  data.forEach((element) => {
    const encounterObj = fEncounter(element);
    encounterArray.push(encounterObj);
  });
  return encounterArray;
}

/**
 * Formats an encounter element into a structured object.
 * @param {Object} element - The encounter element to be formatted.
 * @returns {Object} - The formatted encounter object.
 */
export function fEncounter(element) {
  let encounterObj = {
    id: element.id,
    status: element.status || '',
    class: element.class?.code  || '',
    period_start: element.period?.start || '',
    period_end: element.period?.end || '',
    subject: element.subject?.reference.split('/')[1] || '',
    diagnosis_condition: '',
    location: '',
  };

  if (Array.isArray(element.location)) {
    encounterObj = {
      ...encounterObj,
      location: element.location[0].location.reference.split('/')[1],
    };
  }

  if (Array.isArray(element.diagnosis)) {
    encounterObj = {
      ...encounterObj,
      diagnosis_condition: element.condition[0].reference.split('/')[1],
    };
  }

  return encounterObj;
}
